module.exports = __webpack_public_path__ + "img/search-normal.79d09867.svg";